import { chatModalContext, useChatModalValue } from './context';

export interface ChatModalProviderProps {
  children: ReactNode;
}

export function ChatModalProvider({ children }: ChatModalProviderProps) {
  const value = useChatModalValue();
  return (
    <chatModalContext.Provider value={value}>{children}</chatModalContext.Provider>
  );
}
